<template>
    <div class="applyInfo">
      <van-tabs v-model="active">
          <div class="content">
            <van-tab v-for="item in titleList" :key="item.index" :title="item.title">
              <exportData v-if="item.index == '1'"/>
            <overdue v-if="item.index == '2'"/>
            <overdueAlreadyGet v-if="item.index == '3'"/>
          </van-tab>
          </div>
        </van-tabs>
    </div>
  </template>
  
  <script>
  import PlateNumber from '../plateNo.vue'
  import overdue from './overdue.vue'
  import overdueAlreadyGet from './overdueAlreadyGet.vue'
  import exportData from './exportData.vue';
  export default {
    components:{
      PlateNumber,
      overdue,
      overdueAlreadyGet,
      exportData
    },
    filters:{
    },
    mounted(){
      // this.onSearch()
  },
    data(){
      return{
        active:0,//
        titleList:[
          {'index':'1','title':'报表导出'},
          {'index':'2','title':'未取出'},
          {'index':'3','title':'已取出'}
        ]
      }
    },
    methods:{

    }
  
  }
  </script>
  
  <style lang="scss" >
  .applyInfo{
    .searchContent{
      .van-cell__title{
        line-height: 45px;
      }
    }
  
    .van-nav-bar__left{
      left: 0;
    }
    .van-nav-bar .van-icon{
      color: #0283ef;
    }
    .van-nav-bar__text{
      color: #0283ef;
    }
    .van-search__action{
      color: #0283ef;
      font-size: 18px;
    }
  
    .wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .title{
      margin-top: 3%;
      .cancel{
        float: right;
        margin-right: 3%;
        font-size: 28px;
      }
    }
    .overdueBlock{
      width: 95%;
      // height: 43%;
      border-radius: 8px;
      background-color: #fff;
      .van-cell__value{
        text-align: left;
      }
      .van-field__control{
        width: 90%;
      }
    }
    }
   
  
  }
  
  </style>